import {put,takeLatest,call} from 'redux-saga/effects'
import * as orderService from "../../../services/orderService"

import {
    SET_SELECTED_ORDER,
    SET_SELECTED_ORDER_SUCCESS,
    SET_SELECTED_ORDER_ERROR
}
    from "../../actions/order";
function* setSelectedOrderSaga(action) {
    try {
        let data={}
        
        if(action.payload.term)
            data=yield call(orderService.SearchOrder,action.payload)

        yield put({
            type: SET_SELECTED_ORDER_SUCCESS,
            payload: data
        });

    } catch(error) {
        yield put({
            type: SET_SELECTED_ORDER_ERROR,error: error.data
        });
    }
}

export function* setSelectedOrderSagaWatcher() {
    yield takeLatest(SET_SELECTED_ORDER,setSelectedOrderSaga);
}